// extracted by mini-css-extract-plugin
export default {"wrapper":"AssociateModal_wrapper__FYt5i","tips":"AssociateModal_tips__U1JUM","red":"AssociateModal_red__YpDXD"};